import Resource from '@/api/core/resource'
import appConfig from '@/config/appConfig'
import Interfaz from '@/api/interfaz'

class ProyectoPago extends Resource {
  constructor () {
    super('tesoreria/proyectos-pago')
  }

  buscarComprobantesParaPagar (datos) {
    return this.request.post(
      this.uri
        .concat('/buscar-comprobantes-pagar'),
      datos
    )
  }

  obtenerFCTsPorComprobantes (datos) {
    return this.request.post(
      this.uri
        .concat('/obtener-fcts-comprobantes'),
      datos
    )
  }

  obtenerInfoParaPOCPorCentros (datos) {
    return this.request.post(
      this.uri
        .concat('/obtener-info-poc-centros'),
      datos
    )
  }

  obtenerOrdenesPago (proyectoPagoVersionId, filtros) {
    return this.request.post(this.uri.concat('/').concat(proyectoPagoVersionId).concat('/ordenes-pago'), filtros)
  }

  obtenerComprobantesOrdenPago (proyectoPagoVersionId, ordenPagoId, filtros) {
    return this.request.post(this.uri.concat('/').concat(proyectoPagoVersionId).concat('/ordenes-pago/').concat(ordenPagoId).concat('/comprobantes'), filtros)
  }

  obtenerComprobantes (proyectoPagoVersionId, filtros) {
    return this.request.post(this.uri.concat('/').concat(proyectoPagoVersionId).concat('/comprobantes'), filtros)
  }

  cerrar (item) {
    return this.request.get(
      this.uri
        .concat('/')
        .concat(item.id)
        .concat('/cerrar')
    )
  }

  generarInterfaz (item) {
    return Interfaz.procesarProyectoPago(item.proyecto_pago_id)
  }

  descargar (proyectoPagoVersionId) {
    window.open(
      appConfig.urlServer.concat(
        this.uri
          .concat('/')
          .concat(proyectoPagoVersionId)
          .concat('/descargar')
      )
    )
  }
}

export default new ProyectoPago()
